/**
 * `/finance/settings` — billing configuration for the ORGANIZATION ADMIN
 * (AUTONOMY · Layer 1).
 *
 * The same surface as Admin → Billing's `Configuración` tab, but
 * reachable by a plain org_admin: the `/admin/*` routes require PLATFORM
 * back-office role in the web router, while the server authorizes
 * these endpoints with `ManageBilling ∥ org admin`. Without this route, an academy
 * owner couldn't configure their methods/plans/discounts without a
 * platform role — exactly the kind of dependency AUTONOMY eliminates.
 */
import { createRoute } from "@tanstack/solid-router";
// FLAGS: the entire page is gated by feature (active org).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { msg } from "@lingui/core/macro";
import { Settings } from "@fleet/icons";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer, PageHeader } from "@fleet/ui";
import { BillingSettings } from "@/features/finance/components/billing-settings";

function FinanceSettingsPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="4xl">
      <div class="flex items-start justify-between gap-2">
        <PageHeader
          backTo="/finance"
          title={t(msg`Billing configuration`)}
          description={t(
            msg`Payment methods, price plans, discounts and receipt footer of your academy. Changes are audited in the activity log.`,
          )}
          icon={Settings}
        />
      </div>
      <div class="mt-4">
        <BillingSettings />
      </div>
    </PageContainer>
  );
}

export const financeSettingsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/finance/settings",
  component: withFeatureGate("billing.core", FinanceSettingsPage),
});
